export default [
  {
    path: "/checkout",
    name: "checkout",
    component: () => import(/* webpackChunkName: "checkout" */ "@/pages/Checkout/Checkout.vue"),
    redirect: {
      name: "checkout-package",
    },
    props: (route) => {
      let {
        packageId,
        appId,
        locationId,
        addonId,
        couponCode,
        nickname,
        installApp,
        term,
        hasBigCommerce,
        affiliateId,
        storeBuilderId,
      } = route.query;

      // convert from 1/0 to true false
      installApp = installApp === undefined || Number(installApp) === 1;
      hasBigCommerce = !(hasBigCommerce === undefined || Number(hasBigCommerce) === 0);

      return {
        packageId: packageId ? Number(packageId) : null,
        appId: appId ? Number(appId) : null,
        locationId: locationId ? Number(locationId) : null,
        addonId: addonId ? Number(addonId) : null,
        couponCode,
        nickname,
        installApp,
        term,
        hasBigCommerce,
        affiliateId: affiliateId ? Number(affiliateId) : null,
        storeBuilderId,
      };
    },
    children: [
      // regular checkout
      {
        path: "package",
        name: "checkout-package",
        meta: {
          sidebar: "CHECKOUT_PACKAGE",
        },
        component: () =>
          import(/* webpackChunkName: "checkout" */ "@/pages/Checkout/CheckoutPackage.vue"),
      },
      {
        path: "profile",
        name: "checkout-profile",
        meta: {
          sidebar: "CHECKOUT_PROFILE",
        },
        components: {
          default: () =>
            import(/* webpackChunkName: "checkout" */ "@/pages/Checkout/CheckoutProfile.vue"),
          summary: () =>
            import(
              /* webpackChunkName: "checkout" */ "@/components/display/checkout/CheckoutSummary.vue"
            ),
        },
      },
      {
        path: "details",
        name: "checkout-details",
        meta: {
          sidebar: "CHECKOUT_DETAILS",
        },
        components: {
          default: () =>
            import(/* webpackChunkName: "checkout" */ "@/pages/Checkout/CheckoutDetails.vue"),
          summary: () =>
            import(
              /* webpackChunkName: "checkout" */ "@/components/display/checkout/CheckoutSummary.vue"
            ),
        },
      },
      {
        path: "store-builder",
        name: "checkout-storebuilder",
        meta: {
          sidebar: "CHECKOUT_STOREBUILDER",
        },
        components: {
          default: () =>
            import(/* webpackChunkName: "checkout" */ "@/pages/Checkout/CheckoutStoreBuilder.vue"),
          summary: () =>
            import(
              /* webpackChunkName: "checkout" */ "@/components/display/checkout/CheckoutSummary.vue"
            ),
        },
      },
      {
        path: "billing",
        name: "checkout-billing",
        meta: {
          sidebar: "CHECKOUT_BILLING",
        },
        components: {
          default: () =>
            import(/* webpackChunkName: "checkout" */ "@/pages/Checkout/CheckoutBilling.vue"),
          summary: () =>
            import(
              /* webpackChunkName: "checkout" */ "@/components/display/checkout/CheckoutSummary.vue"
            ),
        },
      },
      {
        path: "payment",
        name: "checkout-payment",
        meta: {
          sidebar: "CHECKOUT_PAYMENT",
        },
        props: (route) => ({
          coupon: route.query.coupon,
        }),
        components: {
          default: () =>
            import(/* webpackChunkName: "checkout" */ "@/pages/Checkout/CheckoutPayment.vue"),
          summary: () =>
            import(
              /* webpackChunkName: "checkout" */ "@/components/display/checkout/CheckoutSummary.vue"
            ),
        },
      },
    ],
  },
  {
    path: "/checkout-free-trial",
    name: "checkout-free-trial",
    component: () =>
      import(/* webpackChunkName: "checkout" */ "@/pages/Checkout/CheckoutTrial.vue"),
    props: (route) => {
      let {
        packageId,
        appId,
        locationId,
        addonId,
        couponCode,
        nickname,
        installApp,
        term,
        hasBigCommerce,
        affiliateId,
        storeBuilderId,
      } = route.query;

      // convert from 1/0 to true false
      installApp = installApp === undefined || Number(installApp) === 1;
      hasBigCommerce = !(hasBigCommerce === undefined || Number(hasBigCommerce) === 0);

      return {
        packageId: packageId ? Number(packageId) : null,
        appId: appId ? Number(appId) : null,
        locationId: locationId ? Number(locationId) : null,
        addonId: addonId ? Number(addonId) : null,
        couponCode,
        nickname,
        installApp,
        term,
        hasBigCommerce,
        affiliateId: affiliateId ? Number(affiliateId) : null,
        storeBuilderId,
      };
    },
    redirect: {
      name: "checkout-free-trial-details",
    },
    meta: {
      authGuard: true,
    },
    children: [
      {
        path: "details",
        name: "checkout-free-trial-details",
        components: {
          default: () =>
            import(/* webpackChunkName: "checkout" */ "@/pages/Checkout/CheckoutTrialDetails.vue"),

          summary: () =>
            import(
              /* webpackChunkName: "checkout" */ "@/components/display/checkout/CheckoutTrialSummary.vue"
            ),
        },
      },
      {
        path: "store-builder",
        name: "checkout-free-trial-storebuilder",
        meta: {
          sidebar: "CHECKOUT_STOREBUILDER",
        },
        components: {
          default: () =>
            import(
              /* webpackChunkName: "checkout" */ "@/pages/Checkout/CheckoutTrialStoreBuilder.vue"
            ),
          summary: () =>
            import(
              /* webpackChunkName: "checkout" */ "@/components/display/checkout/CheckoutTrialSummary.vue"
            ),
        },
      },

      {
        path: "profile",
        name: "checkout-free-trial-profile",
        components: {
          default: () =>
            import(/* webpackChunkName: "checkout" */ "@/pages/Checkout/CheckoutTrialProfile.vue"),

          summary: () =>
            import(
              /* webpackChunkName: "checkout" */ "@/components/display/checkout/CheckoutTrialSummary.vue"
            ),
        },
      },
    ],
  },
];
